module.exports = __webpack_public_path__ + "static/media/pattern-houses@2x.192d9c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern-houses@2x.png
// module id = 295
// module chunks = 0